export default {
  AFNDLamdaToAFND: {
    title: {
      en: "Algorithm for convert NDFA-λ -> NDFA",
      pt: "Algoritmo de conversão AFND-λ -> AFND",
    },
    content: {
      en:
        '<ol><li id="initial-word"><span id="normal">Are start states: clousure-λ(q0).</span></li>' +
        '<ol><li id="circle-items">For all states in clousure-λ are initials in NDFA.</li></ol>' +
        '<li id="initial-word"><span id="normal">For the other states qi:</span></li>' +
        '<ol><li  id="circle-items">considers every state in clousure-λ(qi).</li>' +
        '<li  id="circle-items">consumes, stops in a state qj and then adds the clousure-λ(qj).</li></ol></ol>',
      pt:
        '<ol><li id="initial-word"><span id="normal">São estados iniciais: fecho-λ(q0).</span></li>' +
        '<ol><li id="circle-items">Todos os estados do fecho-λ são iniciais no AFND.</li></ol>' +
        '<li id="initial-word"><span id="normal">Para outros estados de qi:</span></li>' +
        '<ol><li  id="circle-items">considere todo estado em fecho-λ(qi).</li>' +
        '<li  id="circle-items">consome, para em um estado qj e então adiciona o fecho-λ(qj).</li></ol></ol>',
    },
  },
  AFNDToAFD: {
    title: {
      en: "Algorithm for convert NDFA -> DFA",
      pt: "Algoritmo de conversão AFND -> AFD",
    },
    content: {
      en:
        '<ol><li id="initial-word"><span id="normal">It\'s start: the union of all start states: {q0}.</span></li>' +
        '<li id="initial-word"><span id="normal">Each new Q obtains the union of the transitions of its member states.</span></li>' +
        '<li id="initial-word"><span id="normal">Are final: states containing at least one final state.</span></li></ol>',
      pt:
        '<ol><li id="initial-word"><span id="normal">É inicial: a união de todos os estados iniciais: {q0}.</span></li>' +
        '<li id="initial-word"><span id="normal">Cada novo Q obtém a união das transições dos seus estados integrantes.</span></li>' +
        '<li id="initial-word"><span id="normal">São finais: os estados que contém pelo menos um estado final.</span></li></ol>',
    },
  },
  Minimization: {
    title: {
      en: "Minimization Algorithm",
      pt: "Algoritmo de Minimização",
    },
    content: {
      en:
        '<span id="initial-word">Input</span> AFD M = (Q, Σ, δ, q0, F)' +
        '<ol><li id="initial-word"><span id="normal">For all pair of states qi and qj, i < j, do:</span></li>' +
        '<ol><li id="initial-word"><span id="normal">E[i,j] = 1 (visualizing 1=✔ e 0=✖)</li>' +
        '<li id="initial-word"><span id="normal">S[i,j] = ∅</li></ol>' +
        '<li id="initial-word"><span id="normal">For each pair [i,j] i < j, if one is final state and the other isn\'t, do E[i,j] = 0 </span></li>' +
        '<li id="initial-word"><span id="normal">For each pair [i,j] i < j, and E[i,j] = 1 do:</span></li>' +
        '<ol><li id="initial-word"><span id="normal">If there is a ∈ Σ such that δ(qi, a) = qm and δ(qj, a) = qn and (E[m,n] = 0 or E[n,m] = 0) then:</li>' +
        '<li id="initial-word"><span id="normal">Change E[i,j] = 0 and propagate the distinction to the elements of S[i,j]</li>' +
        '<li id="initial-word"><span id="normal">For each a ∈ Σ such that δ(qi, a) = qm and δ(qj, a) = qn</li>' +
        "<ul><li>if m < n and [i,j] ≠ [m,n], then add [i,j] to S[m,n]</li>" +
        "<li>if m > n and [i,j] ≠ [n,m], then add [i,j] to S[n,m]</li></ul></ol>" +
        '<li id="initial-word"><span id="normal">For each E[i,j] = 1, the i and j can be merged</span></li></ol>',
      pt:
        '<span id="initial-word">Entrada</span> AFD M = (Q, Σ, δ, q0, F)' +
        '<ol><li id="initial-word"><span id="normal">Para todos os pares de estado qi e qj, i < j, faça:</span></li>' +
        '<ol><li id="initial-word"><span id="normal">E[i,j] = 1 (visualmente 1=✔ e 0=✖)</li>' +
        '<li id="initial-word"><span id="normal">S[i,j] = ∅</li></ol>' +
        '<li id="initial-word"><span id="normal">Para cada par [i,j] i < j, se um é estado final e o outro não, faça E[i,j] = 0.</span></li>' +
        '<li id="initial-word"><span id="normal">Para cada par [i,j] i < j, e E[i,j] = 1, faça:</span></li>' +
        '<ol><li id="initial-word"><span id="normal">Se existe um a ∈ Σ tal que δ(qi, a) = qm e δ(qj, a) = qn e (E[m,n] = 0 ou E[n,m] = 0), então:</li>' +
        '<li id="initial-word"><span id="normal">E[i,j] = 0 e propague a distinção aos elementos de S[i,j]</li>' +
        '<li id="initial-word"><span id="normal">Para cada a ∈ Σ tal que δ(qi, a) = qm e δ(qj, a) = qn</li>' +
        "<ul><li>se m < n e [i,j] ≠ [m,n], então adicione [i,j] à S[m,n]</li>" +
        "<li>se m > n e [i,j] ≠ [n,m], então adicionar [i,j] à S[n,m]</li></ul></ol>" +
        '<li id="initial-word"><span id="normal">Para cada E[i,j] = 1, i e j podem ser fundidos</span></li></ol>',
    },
  },
};
